import { SecuritySchemeElement } from '@swagger-api/apidom-ns-openapi-3-0';
class SecurityScheme extends SecuritySchemeElement {}
export default SecurityScheme;